<template>
    <section :class="`${backgroundColor}`">
        <div class="px-4 py-8 mx-auto max-w-7xl md:py-16 xl:px-8">
            <h2 class="text-white md:mb-12 mb-6 text-3xl md:text-4xl font-ww-bold xl:!leading-none xl:text-42 text-center" v-html="mainHeading">
            </h2>
            <div class="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-x-4 md:gap-x-6 lg:gap-x-6 xl:gap-x-10 gap-y-4 md:gap-y-6 2xl:gap-y-10">
                <template v-for="(image, index) in testimonialImages" :key="index">
                    <div class="col-span-1">
                        <nuxt-img sizes="xs:139px sm:187px md:229px lg:176px xl:211" :src="image.src" class="w-full" :alt="image.alt" loading="lazy"
                            format="webp" width="211" height="323" />
                    </div>
                    <div v-if="index === 7" class="hidden col-span-1 md:hidden sm:block"></div>
                </template>
            </div>
            <div class="grid grid-cols-1 mt-10 md:mt-16 md:grid-cols-2 gap-x-5 lg:gap-x-10 gap-y-5 lg:gap-y-10">
                <div v-for="(testimonial, index) in testimonials" :key="index" class="bg-[#0F4846] col-span-1 flex flex-col justify-between px-6 py-5 xl:px-14 xl:py-10">
                    <div>
                        <div class="text-xl text-white xl:text-2xl font-ww-bold" v-html="testimonial.title">
                        </div>
                        <div class="mt-3 text-white lg:mt-6 lg:text-lg font-ww-regular !leading-6" v-html="testimonial.content">
                        </div>
                    </div>
                    <div class="mt-10 space-y-1">
                        <svg width="94" height="15" viewBox="0 0 94 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5.02861 4.50981C5.02861 4.50981 2.24738 4.81786 0.392058 5.02381C0.224833 5.04406 0.0769701 5.15583 0.0215216 5.3257C-0.0339269 5.49557 0.0215215 5.67247 0.14474 5.78425C1.52303 7.04196 3.59399 8.92545 3.59399 8.92545C3.59223 8.92545 3.02542 11.6653 2.64873 13.4934C2.61704 13.6588 2.67689 13.834 2.82123 13.9387C2.96469 14.0434 3.14952 14.0452 3.29475 13.9633C4.91772 13.041 7.34865 11.6539 7.34865 11.6539C7.34865 11.6539 9.78046 13.041 11.4008 13.9642C11.5487 14.0452 11.7335 14.0434 11.8769 13.9387C12.0213 13.834 12.0811 13.6588 12.0486 13.4942C11.6719 11.6653 11.1059 8.92545 11.1059 8.92545C11.1059 8.92545 13.1769 7.04196 14.5552 5.78689C14.6784 5.67159 14.733 5.49469 14.6784 5.3257C14.6238 5.15671 14.476 5.04494 14.3088 5.02557C12.4534 4.81786 9.67133 4.50981 9.67133 4.50981C9.67133 4.50981 8.51835 1.95918 7.74999 0.25876C7.67782 0.106497 7.52644 0 7.34865 0C7.17086 0 7.0186 0.107377 6.94995 0.25876C6.18071 1.95918 5.02861 4.50981 5.02861 4.50981Z"
                                fill="#F1594B" />
                            <path
                                d="M24.7278 4.50981C24.7278 4.50981 21.9466 4.81786 20.0913 5.02381C19.9241 5.04406 19.7762 5.15583 19.7207 5.3257C19.6653 5.49557 19.7207 5.67247 19.844 5.78425C21.2223 7.04196 23.2932 8.92545 23.2932 8.92545C23.2914 8.92545 22.7246 11.6653 22.3479 13.4934C22.3163 13.6588 22.3761 13.834 22.5205 13.9387C22.6639 14.0434 22.8487 14.0452 22.994 13.9633C24.6169 13.041 27.0479 11.6539 27.0479 11.6539C27.0479 11.6539 29.4797 13.041 31.1 13.9642C31.2479 14.0452 31.4327 14.0434 31.5762 13.9387C31.7205 13.834 31.7804 13.6588 31.7478 13.4942C31.3711 11.6653 30.8052 8.92545 30.8052 8.92545C30.8052 8.92545 32.8761 7.04196 34.2544 5.78689C34.3776 5.67159 34.4322 5.49469 34.3776 5.3257C34.3231 5.15671 34.1752 5.04494 34.008 5.02557C32.1527 4.81786 29.3705 4.50981 29.3705 4.50981C29.3705 4.50981 28.2176 1.95918 27.4492 0.25876C27.377 0.106497 27.2257 0 27.0479 0C26.8701 0 26.7178 0.107377 26.6492 0.25876C25.8799 1.95918 24.7278 4.50981 24.7278 4.50981Z"
                                fill="#F1594B" />
                            <path
                                d="M44.4271 4.50981C44.4271 4.50981 41.6458 4.81786 39.7905 5.02381C39.6233 5.04406 39.4754 5.15583 39.42 5.3257C39.3645 5.49557 39.42 5.67247 39.5432 5.78425C40.9215 7.04196 42.9924 8.92545 42.9924 8.92545C42.9907 8.92545 42.4239 11.6653 42.0472 13.4934C42.0155 13.6588 42.0753 13.834 42.2197 13.9387C42.3631 14.0434 42.548 14.0452 42.6932 13.9633C44.3162 13.041 46.7471 11.6539 46.7471 11.6539C46.7471 11.6539 49.1789 13.041 50.7992 13.9642C50.9471 14.0452 51.1319 14.0434 51.2754 13.9387C51.4197 13.834 51.4796 13.6588 51.447 13.4942C51.0703 11.6653 50.5044 8.92545 50.5044 8.92545C50.5044 8.92545 52.5753 7.04196 53.9536 5.78689C54.0769 5.67159 54.1314 5.49469 54.0769 5.3257C54.0223 5.15671 53.8744 5.04494 53.7072 5.02557C51.8519 4.81786 49.0698 4.50981 49.0698 4.50981C49.0698 4.50981 47.9168 1.95918 47.1484 0.25876C47.0763 0.106497 46.9249 0 46.7471 0C46.5693 0 46.417 0.107377 46.3484 0.25876C45.5791 1.95918 44.4271 4.50981 44.4271 4.50981Z"
                                fill="#F1594B" />
                            <path
                                d="M64.1282 4.50981C64.1282 4.50981 61.347 4.81786 59.4917 5.02381C59.3244 5.04406 59.1766 5.15583 59.1211 5.3257C59.0657 5.49557 59.1211 5.67247 59.2443 5.78425C60.6226 7.04196 62.6936 8.92545 62.6936 8.92545C62.6918 8.92545 62.125 11.6653 61.7483 13.4934C61.7167 13.6588 61.7765 13.834 61.9208 13.9387C62.0643 14.0434 62.2491 14.0452 62.3944 13.9633C64.0173 13.041 66.4483 11.6539 66.4483 11.6539C66.4483 11.6539 68.8801 13.041 70.5004 13.9642C70.6483 14.0452 70.8331 14.0434 70.9766 13.9387C71.1209 13.834 71.1807 13.6588 71.1482 13.4942C70.7715 11.6653 70.2056 8.92545 70.2056 8.92545C70.2056 8.92545 72.2765 7.04196 73.6548 5.78689C73.778 5.67159 73.8326 5.49469 73.778 5.3257C73.7235 5.15671 73.5756 5.04494 73.4084 5.02557C71.553 4.81786 68.7709 4.50981 68.7709 4.50981C68.7709 4.50981 67.618 1.95918 66.8496 0.25876C66.7774 0.106497 66.626 0 66.4483 0C66.2705 0 66.1182 0.107377 66.0496 0.25876C65.2803 1.95918 64.1282 4.50981 64.1282 4.50981Z"
                                fill="#F1594B" />
                            <path
                                d="M83.8274 4.50981C83.8274 4.50981 81.0462 4.81786 79.1909 5.02381C79.0237 5.04406 78.8758 5.15583 78.8203 5.3257C78.7649 5.49557 78.8203 5.67247 78.9436 5.78425C80.3219 7.04196 82.3928 8.92545 82.3928 8.92545C82.3911 8.92545 81.8243 11.6653 81.4476 13.4934C81.4159 13.6588 81.4757 13.834 81.6201 13.9387C81.7635 14.0434 81.9484 14.0452 82.0936 13.9633C83.7165 13.041 86.1475 11.6539 86.1475 11.6539C86.1475 11.6539 88.5793 13.041 90.1996 13.9642C90.3475 14.0452 90.5323 14.0434 90.6758 13.9387C90.8201 13.834 90.88 13.6588 90.8474 13.4942C90.4707 11.6653 89.9048 8.92545 89.9048 8.92545C89.9048 8.92545 91.9757 7.04196 93.354 5.78689C93.4772 5.67159 93.5318 5.49469 93.4772 5.3257C93.4227 5.15671 93.2748 5.04494 93.1076 5.02557C91.2523 4.81786 88.4702 4.50981 88.4702 4.50981C88.4702 4.50981 87.3172 1.95918 86.5488 0.25876C86.4766 0.106497 86.3253 0 86.1475 0C85.9697 0 85.8174 0.107377 85.7488 0.25876C84.9795 1.95918 83.8274 4.50981 83.8274 4.50981Z"
                                fill="#F1594B" />
                        </svg>
                        <div class="text-lg text-white font-ww-medium md:text-xl">
                            {{ testimonial.author }}
                        </div>
                        <div class="text-base text-white font-ww-regular md:text-lg">
                            {{ testimonial.location }}
                        </div>
                    </div>
                </div>
            </div>

          <div class="mt-6 md:mt-10">
            <button @click="scrollTo(buttonHref)"
            class="flex items-center px-12 py-3 mx-auto text-base rounded-full md:text-xl md:px-24 lg:py-4 font-ww-medium btn-red gap-x-2">{{ buttonText }}</button>
          </div>

          

          <div class="mt-2 text-base text-center text-white font-ww-regular">
            {{ limitedSuppliesText }}
           </div>


        </div>
    </section>
</template>

<script setup>
const props = defineProps({
  backgroundColor: {
    type: String,
    default: 'bg-lifeboost-green-200',
  },
  mainHeading: {
    type: String,
    default: 'Over 60 Million Cups Served–and Counting',
  },
  buttonHref: {
    type: String,
    default: 'products',
  },
  buttonText: {
    type: String,
    default: 'Get Discount',
  },
  limitedSuppliesText: {
    type: String,
    default: 'Limited supplies available. Special discount available today.',
  },
  testimonialImages: {
    type: Array,
    default: () => [
      { src: '/assets/images/review-decaf-1.jpg', alt: 'Testimonial 1' },
      { src: '/assets/images/review-decaf-2.jpg', alt: 'Testimonial 2' },
      { src: '/assets/images/review-decaf-3.jpg', alt: 'Testimonial 3' },
      { src: '/assets/images/review-decaf-4.jpg', alt: 'Testimonial 4' },
      { src: '/assets/images/review-decaf-5.jpg', alt: 'Testimonial 5' },
      { src: '/assets/images/review-decaf-6.jpg', alt: 'Testimonial 6' },
      { src: '/assets/images/review-decaf-7.jpg', alt: 'Testimonial 7' },
      { src: '/assets/images/review-decaf-8.jpg', alt: 'Testimonial 8' },
      { src: '/assets/images/review-decaf-9.jpg', alt: 'Testimonial 9' },
      { src: '/assets/images/review-decaf-10.jpg', alt: 'Testimonial 10' },
    ]
  },
  testimonials: {
    type: Array,
    default: () => [
      {
        title: 'Medium roast decaf coffee pods',
        content: "I absolutely love the lifeboost medium roast coffee pods! I have heart and digestion issues and had stopped drinking coffee entirely. But my grandson discovered the Lifeboost coffee site and we gave it a try. The best coffee ever!",
        author: 'Margie H.',
        location: 'United States'
      },
      {
        title: 'Hands down.....the best coffee I have ever had.',
        content: "With gut issues, I needed something that tasted like REAL coffee without the acid taste or feeling. Full bodied and delicious. Prior to this my favorite coffee was a couple that are imported to Germany!!! I fell in love with coffee there 40 years ago because of what they want in their restaurants and the population in general. Anyway - I love the Lifeboost MEDIUM roast ground, both regular and decaf. I make them in my Nespresso machine with re-used pods and covers. I use a half & half or nutpod creamer. WOW!!! The very best. No stomach/gut problems. Just great taste. I generally don't care for flavored coffee so I cannot comment on them.",
        author: 'Deem',
        location: 'Canada'
      },
      {
        title: 'BEST DECAF',
        content: "I stopped drinking coffee over a year ago due to acid reflux. After some research and trials of other brands, Lifeboost is by far the best low acid decaf! I have zero stomach upset and I absolutely love the taste. I'm so happy with my morning cup of coffee again!!",
        author: 'Gwen O.',
        location: 'Nevada'
      },
      {
        title: 'Cannot Tell the Difference in "Regular"',
        content: "This Decaf is so good that even my husband can't tell the difference from his regular Lifeboost coffee. It's a winner.",
        author: 'Debbie N.',
        location: 'California'
      }
    ]
  }
});

defineBuilderComponent({
  friendlyName: 'TestimonialsListWithText',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      friendlyName: 'Background Color',
      defaultValue: 'bg-lifeboost-green-200',
    },
    {
      name: 'mainHeading',
      type: 'richText',
      friendlyName: 'Main Heading',
      defaultValue: 'Over 60 Million Cups Served–and Counting',
    },
    {
      name: 'buttonHref',
      type: 'text',
      friendlyName: 'Button Link',
      defaultValue: 'products',
    },
    {
      name: 'buttonText',
      type: 'text',
      friendlyName: 'Button Text',
      defaultValue: 'Get Discount',
    },
    {
      name: 'limitedSuppliesText',
      type: 'text',
      friendlyName: 'Limited Supplies Text',
      defaultValue: 'Limited supplies available. Special discount available today.',
    },
    {
      name: 'testimonialImages',
      type: 'list',
      friendlyName: 'Testimonial Images',
      defaultValue: [
        { src: '/assets/images/review-decaf-1.jpg', alt: 'Testimonial 1' },
        { src: '/assets/images/review-decaf-2.jpg', alt: 'Testimonial 2' },
        { src: '/assets/images/review-decaf-3.jpg', alt: 'Testimonial 3' },
        { src: '/assets/images/review-decaf-4.jpg', alt: 'Testimonial 4' },
        { src: '/assets/images/review-decaf-5.jpg', alt: 'Testimonial 5' },
        { src: '/assets/images/review-decaf-6.jpg', alt: 'Testimonial 6' },
        { src: '/assets/images/review-decaf-7.jpg', alt: 'Testimonial 7' },
        { src: '/assets/images/review-decaf-8.jpg', alt: 'Testimonial 8' },
        { src: '/assets/images/review-decaf-9.jpg', alt: 'Testimonial 9' },
        { src: '/assets/images/review-decaf-10.jpg', alt: 'Testimonial 10' },
      ],
      subFields: [
        {
          name: 'src',
          type: 'file',
          friendlyName: 'Image Source',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
        },
        {
          name: 'alt',
          type: 'text',
          friendlyName: 'Alt Text',
        }
      ]
    },
    {
      name: 'testimonials',
      type: 'list',
      friendlyName: 'Testimonials',
      defaultValue: [
        {
          title: 'Medium roast decaf coffee pods',
          content: "I absolutely love the lifeboost medium roast coffee pods! I have heart and digestion issues and had stopped drinking coffee entirely. But my grandson discovered the Lifeboost coffee site and we gave it a try. The best coffee ever!",
          author: 'Margie H.',
          location: 'United States'
        },
        {
          title: 'Hands down.....the best coffee I have ever had.',
          content: "With gut issues, I needed something that tasted like REAL coffee without the acid taste or feeling. Full bodied and delicious. Prior to this my favorite coffee was a couple that are imported to Germany!!! I fell in love with coffee there 40 years ago because of what they want in their restaurants and the population in general. Anyway - I love the Lifeboost MEDIUM roast ground, both regular and decaf. I make them in my Nespresso machine with re-used pods and covers. I use a half & half or nutpod creamer. WOW!!! The very best. No stomach/gut problems. Just great taste. I generally don't care for flavored coffee so I cannot comment on them.",
          author: 'Deem',
          location: 'Canada'
        },
        {
          title: 'BEST DECAF',
          content: "I stopped drinking coffee over a year ago due to acid reflux. After some research and trials of other brands, Lifeboost is by far the best low acid decaf! I have zero stomach upset and I absolutely love the taste. I'm so happy with my morning cup of coffee again!!",
          author: 'Gwen O.',
          location: 'Nevada'
        },
        {
          title: 'Cannot Tell the Difference in "Regular"',
          content: "This Decaf is so good that even my husband can't tell the difference from his regular Lifeboost coffee. It's a winner.",
          author: 'Debbie N.',
          location: 'California'
        }
      ],
      subFields: [
        {
          name: 'title',
          type: 'richText',
          friendlyName: 'Testimonial Title',
        },
        {
          name: 'content',
          type: 'richText',
          friendlyName: 'Testimonial Content',
        },
        {
          name: 'author',
          type: 'text',
          friendlyName: 'Author Name',
        },
        {
          name: 'location',
          type: 'text',
          friendlyName: 'Author Location',
        }
      ]
    }
  ],
});
</script>